var map = {
	"./img-19-03-01.png": 5180,
	"./img-19-03-02.png": 7267,
	"./img-19-03-03.png": 1918,
	"./img-19-03-04.png": 4437,
	"./img-19-03-05.png": 1062,
	"./img-19-03-06.png": 9518,
	"./img-19-03-07.png": 6090,
	"./img-19-03-08.png": 1549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4305;